import { render, staticRenderFns } from "./Project3Zh.vue?vue&type=template&id=6bf1da41&scoped=true&"
import script from "./Project3Zh.vue?vue&type=script&lang=js&"
export * from "./Project3Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project3Zh.vue?vue&type=style&index=0&id=6bf1da41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf1da41",
  null
  
)

export default component.exports